/*
 * @Author: lidan
 * @Date: 2020-11-10 10:47:13
 * @LastEditTime: 2021-06-03 10:38:33
 * @LastEditors: lidan
 * @Description: 订单应收费用api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\orderReceivable.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取订单应收费用表格数据
export function orderReportReceivable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/orderReport/income`,
    method: "post",
    data
  });
}

//获取表头数据
export function getColumn(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/getColumn`,
    method: "get",
    params
  });
}

// 根据ID查询规则详情
export function ruleInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/report/ruleInfo`,
    method: "get",
    params
  });
}

// 导出订单应收费用
export function exportOrderReceivable(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/orderReport/export/income`,
    method: "post",
    data
  });
}

// 编辑调整费用
export function changeFeeOrderWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/waybillOrderAdjust/changeFee`,
    method: "post",
    data
  });
}

// 查看调整费用历史
export function getHistoryOrderWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/waybillOrderAdjust/getHistory`,
    method: "post",
    data
  });
}
